import { Component, Inject } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import { DEFAULT_IMAGE_URL, IMAGE_BASE_URL } from "app/app.constants";
import { CartResultLineItemSelection, GroupedCartResultLineItemSelection } from "entities/cart-result";
import { groupCumminsVinItems } from "helpers";
import { getImageHelper } from "helpers/get-image";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AppState } from "store/app-state";
import * as BranchSelectors from "store/branch/branch.selectors";
import * as CartSelectors from "store/cart/cart.selectors";

@Component({
    selector: "app-view-all-parts",
    templateUrl: "./view-all-parts.component.html",
    styleUrls: ["./view-all-parts.component.scss"],
    standalone: false
})
export class ViewAllPartsComponent {

  hasCouponData$ = this.store.select(CartSelectors.hasSapCoupons);
  selectCartPartItems$: Observable<GroupedCartResultLineItemSelection[]> = this.store.select(CartSelectors.selectCartPartItems).pipe(
    map((items) => groupCumminsVinItems(items as CartResultLineItemSelection[]))
  );
  currencyCode$ = this.store.select(BranchSelectors.selectCurrencyCode);

  constructor(
    private activeModal: NgbActiveModal,
    @Inject(IMAGE_BASE_URL) public imageBaseUrl: string,
    @Inject(DEFAULT_IMAGE_URL) public defaultImage: string,
    private store: Store<AppState>
  ) {}

  closeModal(): void {
    this.activeModal.dismiss();
  }

  getImage(image: string, imageBaseUrl: string, imageSize: string) {
    return getImageHelper(image, imageBaseUrl, imageSize);
  }
}
